<template>
  <div
    class="article-list-component"
    :class="className"
    :style="{ margin: `0 -${gutter}px` }"
  >
    <ArticleItem
      v-for="(item, index) in list"
      :key="`${item.id}_${index}`"
      :item="item"
      :type="type"
      :size="size"
      :theme="theme"
      :style="{ marginLeft: `${gutter}px`, marginRight: `${gutter}px` }"
      :link-target="linkTarget"
    ></ArticleItem>
  </div>
</template>

<script>
import ArticleItem from './ArticleItem'

export default {
  components: {
    ArticleItem
  },
  props: {
    type: {
      type: String,
      default: 'normal-card'
    },
    list: {
      type: Array,
      default: () => []
    },
    gutter: {
      type: [Number, String],
      default: 12
    },
    size: {
      validator(value) {
        return ['small', 'normal'].includes(value)
      },
      default: 'normal'
    },
    theme: { type: String, default: 'normal' },
    // 是否需要在新tab页打开
    linkTarget: { type: String, default: '_seft' }
  },
  computed: {
    className() {
      return this.type !== 'line-card' ? 'app-flex-row' : ''
    }
  }
}
</script>
